<template lang="pug">
  .all-vacancies
    .content-wrap
      .section
        .container
          h1 {{ gettext('All vacancies') }}
          .white-fone(v-if="loading")
            .columns.is-multiline
              .column
                Loading
          .vacancies-wrap
            job-preview(v-for="(offer, key) in jobofferList" :data="offer" :key="key" @delete="getData(currentPage)")
            router-link.wrap-link(:to="{name: 'CreateJob', params: {lang: getLanguage}}" v-if="!loading")
              .white-fone.add
                .columns.is-multiline
                  .column
                    .mdi.mdi-plus.block
          vue-paginate(
            v-if="joboffers.total_pages"
            :page-count="joboffers.total_pages"
            :page-range="3"
            :initial-page="currentPage-1"
            :clickHandler="toPage"
          )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import VuePaginate from '@/components/paginate'
import Loading from '@/components/stretch-spinner'
import JobPreview from './parts/job-preview'
import mixin from '@/mixins'

export default {
  name: 'MyJobs',
  mixins: [
    mixin
  ],
  components: {
    VuePaginate,
    Loading,
    JobPreview
  },
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  data () {
    return {
      joboffers: {},
      loading: false,
      currentPage: parseInt(this.$route.query.page) || 1
    }
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'employerGetVacancies'
    ]),
    getData: function (page) {
      this.loading = true
      this.employerGetVacancies({page: page, size: this.pageSize}).then(res => {
        this.joboffers = res
        this.$router.replace({name: this.$route.name, params: {lang: this.getLanguage}, query: {page: res.page_num}})
        this.loading = false
      })
    },
    toPage (page) {
      this.getData(page)
      this.currentPage = +page
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('My jobs'),
        titleTemplate: null
      }
    },
    pageSize: function () {
      return (this.$store.state.pageSize - 1) || 8
    },
    jobofferList: function () {
      return (this.joboffers.items || []).reverse()
    }
  },
  created () {
    this.getData(this.currentPage)
  }
}

</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/profile/jobs/index.vue